export class ArrayUtils {
  static groupBy = <T>(array: T[], predicate: (v: T) => string) =>
    array.reduce(
      (acc, value) => {
        (acc[predicate(value)] ||= []).push(value);
        return acc;
      },
      {} as { [key: string]: T[] },
    );

  static unique = (items: any[]) => Array.from(new Set(items));
}
